import type { AppState } from 'state/state.model';

export function isApplicationCrashed(state: AppState): boolean {
  return state.appCrash.isCrashed;
}

export function isAutomaticEmailSent(state: AppState): boolean {
  return state.appCrash.isAutomaticEmailSent ?? false;
}

export function getAppCrashErrorMessage(state: AppState): string {
  if (state.appCrash.isCrashed) {
    return state.appCrash.technicalErrorMessage;
  }
  return 'no application crash, everything is fine';
}
